// extracted by mini-css-extract-plugin
export default {"cls1":"SubmittedErrorDetails-ReadableMessage_cls1__-hl1a","cls2":"SubmittedErrorDetails-ReadableMessage_cls2__HgOp3 SubmittedErrorDetails-ReadableMessage_cls1__-hl1a"};